<h1 mat-dialog-title [innerHtml]="(message$|async)" ></h1>
<div mat-dialog-actions>
  <button mat-raised-button
  color="warn"
  (click)="closeDialog('continue')">Ok</button>
  <button mat-raised-button 
  color="primary" (click)="closeDialog('')">Cancel</button>
</div>